// extracted by mini-css-extract-plugin
module.exports = {"p1":"Paragraph_p1__1Re1Y","p2":"Paragraph_p2__3IGGP","p3":"Paragraph_p3__3T8Mz","p4":"Paragraph_p4__14gpL","p5":"Paragraph_p5__3jiPc","p6":"Paragraph_p6__HPfL9"};